<template>
  <div class="columns is-centered">
    <div class="column is-7 onboarding-welcome-share-view--container">
      <h1 class="has-text-weight-bold">Welcome to {{ brandName }}!</h1>
      <h1>You’re on your way to a happy lawn</h1>
      <LsShareMain class="onboarding-welcome-share-view--share-main" />
      <LsButton
        text="continue to my services"
        track-id="onboarding_welcome_share_view-continue"
        @click="
          $router.replace({
            name: 'services',
          })
        "
      />
    </div>
  </div>
</template>

<script>
import { LsButton } from '@/components/common';
import { LsShareMain } from '@/components';
import { themedComponentMixin } from '@/mixins';
import { mapState } from 'vuex';

export default {
  name: 'OnboardingWelcomeShareView',
  components: {
    LsButton,
    LsShareMain,
  },
  mixins: [themedComponentMixin],
  computed: {
    ...mapState(['featureFlags']),
  },
};
</script>

<style lang="scss" scoped>
.onboarding-welcome-share-view--container {
  text-align: center;
}

.onboarding-welcome-share-view--share-main {
  margin: 20px 0;
}

@media (max-width: $mobile-max-width) {
  .onboarding-welcome-share-view--container {
    h1:first-of-type {
      font-size: $size-2;
    }
    h1:last-of-type {
      font-size: $size-5;
    }
  }

  .onboarding-welcome-share-view--share-main {
    border-top: 1px solid $primary-light;
    border-bottom: 1px solid $primary-light;
    padding: 20px 0;
  }
}
.themed-app {
  @media (max-width: $mobile-max-width) {
    .onboarding-welcome-share-view--container {
      h1:first-of-type {
        font-size: $theme-txt-title;
      }
      h1:last-of-type {
        font-size: $theme-txt-body;
      }
    }

    .onboarding-welcome-share-view--share-main {
      border-bottom: $theme-color-primary-light;
    }
  }
}
</style>
